import {
  KeyboardArrowDown as ArrowDropDownIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { Container, IconButton, Button } from '@mui/material';

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { signOut } from '../api/AuthAPI.js';
import AdminSidebar from '../components/adhara/admin/AdminSidebar.js';
import {
  CoursesIcon,
  DatabaseIcon,
  EventsIcon,
  TrainingsIcon,
  ResourcesIcon,
  ShopIcon,
  SponsorsIcon,
} from '../components/adhara/icons/AdminIcons.js';
import AdminOnly from '../components/auth/AdminOnly.js';
import ButtonLight from '../components/buttons/ButtonLight.js';
import ConfirmedButton from '../components/buttons/ConfirmedButton.js';
import ShadowCard from '../components/card/ShadowCard.js';
import styles from './AdminLayout.module.css';
import AppLayout from './AppLayout.js';

const AdminLayout = (props) => {
  const location = useLocation();
  const selectedTab = navigation.find((item) =>
    location.pathname.includes(item.url)
  );

  const navigate = useNavigate();

  const logout = () =>
    signOut()
      .then(() => (window.location.href = '/'))
      .catch(console.error);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleChangeMenuState = (state) => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <AppLayout title={props.title + ' - Admin'}>
      <AdminOnly>
        <div className={styles.adminLayout}>
          <AdminSidebar navigation={navigation} />
          <div className={styles.content}>
            <Container className={styles.container}>
              {selectedTab && (
                <ShadowCard className={styles.header}>
                  {selectedTab.icon}
                  <h2>{selectedTab.label}</h2>
                </ShadowCard>
              )}
              {props.children}
            </Container>
          </div>

          <div className={styles.buttons}>
            <ButtonLight to="/">Voltar ao Site</ButtonLight>
            <div
              className={styles.settingsMenu}
              onMouseLeave={() => handleChangeMenuState()}
            >
              <IconButton
                className={styles.iconButton}
                tabIndex={0}
                role="button"
                aria-controls="settings-menu"
                aria-haspopup="true"
                onMouseEnter={() => handleChangeMenuState()}
              >
                <>
                  <PersonIcon className={styles.icon} />
                  <div className={styles.dropdownIconContainer}>
                    <ArrowDropDownIcon className={styles.dropdownIcon} />
                  </div>
                </>
              </IconButton>
              {isMenuOpen && (
                <div className={styles.menuContainer}>
                  <div id="menu" className={styles.menu}>
                    <Button
                      type={'button'}
                      onClick={() => navigate('/profile/details')}
                      className={styles.menuItem}
                    >
                      <div className={styles.label}>Editar Perfil</div>
                    </Button>

                    <div className={styles.menuItemBottomDivision} />

                    <ConfirmedButton
                      className={styles.menuItem}
                      confirmText="Deseja mesmo terminar sessão?"
                      confirmTitle="Sair"
                      onClick={logout}
                    >
                      <div className={styles.label}>Sair</div>
                    </ConfirmedButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AdminOnly>
    </AppLayout>
  );
};

// default field on items?
const navigation = [
  {
    label: 'Eventos',
    url: '/admin/events',
    icon: <EventsIcon />,
    items: [
      { label: 'Adicionar Evento', path: '/add' },
      { label: 'Validar Ticket', path: '/validate' },
    ],
  },
  {
    label: 'Cursos Online',
    url: '/admin/courses',
    icon: <CoursesIcon />,
    items: [{ label: 'Adicionar Curso', path: '/add' }],
  },
  {
    label: 'Formações',
    url: '/admin/training',
    icon: <TrainingsIcon />,
    items: [
      { label: 'Formações', path: '' },
      { label: 'Criar Formação', path: '/add' },
    ],
  },
  {
    label: 'Recursos',
    url: '/admin/resources',
    icon: <ResourcesIcon />,
    items: [
      { label: 'Calculadoras', path: '/calculators' },
      { label: 'Árvores de Decisão', path: '/trees' },
      { label: 'Conversores', path: '/tables' },
      { label: 'Guidelines', path: '/guidelines' },
      { label: 'Infografias', path: '/infos' },
      { label: 'Folhetos', path: '/folhetos' },
    ],
  },
  {
    label: 'Loja',
    url: '/admin/shop',
    icon: <ShopIcon />,
    items: [
      { label: 'Produtos', path: '/manage/products' },
      { label: 'Categorias', path: '/manage/categories' },
      { label: 'Filtros', path: '/manage/filters' },
      { label: 'Logotipos', path: '/manage/logos' },
      { label: 'Encomendas', path: '/manage/orders' },
    ],
  },
  {
    label: 'Sponsors',
    url: '/admin/sponsors',
    icon: <SponsorsIcon />,
    items: [{ label: 'Adicionar Sponsor', path: '/add' }],
  },
  {
    // pág 31. se calhar fazer um component para aqueles cards (LinkCard) que tem label e icone
    // usados aqui no admin, na página de recursos e na navbar
    label: 'Database',
    url: '/admin/database',
    icon: <DatabaseIcon />,
    items: [
      { label: 'Utilizadores', path: '/users' },
      { label: 'Palestrantes', path: '/lecturers' },
      { label: 'Formadores', path: '/instructors' },
      { label: 'Parceiros', path: '/partners' },
      { label: 'Especialidades', path: '/specialties' },
      { label: 'Tags', path: '/tags' },
      { label: 'Tag Icons', path: '/tag-icons' },
      { label: 'Público Alvo', path: '/target-audience' },
      { label: 'Adicionar Contas', path: '/accounts' },
      { label: 'FAQs', path: '/faqs' },
      { label: 'Training FAQs', path: '/training-faqs' },
      { label: 'Termos & Condições', path: '/terms' },
      { label: 'Política de Privacidade', path: '/privacy' },
      { label: 'Imagens de Capa', path: '/covers' },
      { label: 'Vídeos em Destaque', path: '/videos' },
      { label: 'Notícias', path: '/articles' },
      { label: 'Códigos de Desconto', path: '/discounts' },
      { label: 'Descontos Diretos', path: '/direct-discounts' },
    ],
  },
  {
    label: 'Países e Línguas',
    url: '/admin/languages',
    icon: <SponsorsIcon />,
    items: [
      { label: 'Adicionar País', path: '/countries/add' },
      { label: 'Adicionar Língua', path: '/languages/add' },
      { label: 'Adicionar Preço', path: '/prices/add' },
      { label: 'Adicionar Moedas', path: '/currencies/add' },
    ],
  },
];

export default AdminLayout;
